/** Small tree glyph beside the replacement count on a full chip. */
import type { ReactElement } from 'react';

export function WorkshopsCalendarChipTreeIcon({ size }: { size: number }): ReactElement {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
      style={{ flexShrink: 0 }}
    >
      <path d="M12 2l6 9h-4l5 7H5l5-7H6z" />
      <rect x={11} y={17} width={2} height={4} />
    </svg>
  );
}
